<template>
  <div class="VueCarousel-navigation">
    <a href="#"
      class="VueCarousel-navigation-button VueCarousel-navigation-prev"
      v-on:click.prevent="triggerPageAdvance('backward')"
      v-bind:class="{ 'VueCarousel-navigation--disabled': !canAdvanceBackward }"
      v-html="prevLabel"></a>
    <a href="#"
      class="VueCarousel-navigation-button VueCarousel-navigation-next"
      v-on:click.prevent="triggerPageAdvance()"
      v-bind:class="{ 'VueCarousel-navigation--disabled': !canAdvanceForward }"
      v-html="nextLabel"></a>
  </div>
</template>

<script>
  export default {
    name: "Navigation",
    data() {
      return {
        parentContainer: this.$parent,
      }
    },
    props: {
      /**
       * Amount of padding to apply around the label in pixels
       */
      clickTargetSize: {
        type: Number,
        default: 8
      },
      /**
       * Text content of the navigation next button
       */
      nextLabel: {
        type: String,
        default: ""
      },
      /**
       * Text content of the navigation prev button
       */
      prevLabel: {
        type: String,
        default: ""
      },
    },
    computed: {
      canAdvanceForward() {
        return this.parentContainer.canAdvanceForward || false
      },
      canAdvanceBackward() {
        return this.parentContainer.canAdvanceBackward || false
      },
    },
    methods: {
      triggerPageAdvance(direction) {
        if (direction) {
          this.$parent.advancePage(direction)
        } else {
          this.$parent.advancePage()
        }
      },
    },
  }
</script>

<style scoped>
  .VueCarousel-navigation
  {
    position: absolute;
    top: 12.4vw;
    left: 0;
    width: 100%;
    padding: 0;
    height: 2vw;
    z-index: 1;
  }

  .VueCarousel-navigation-next {
    transform: rotate(90deg);
    right: 12vw;
  }

  .VueCarousel-navigation-prev {
    transform: rotate(-90deg);
    left: 12vw;
  }

  .VueCarousel-navigation--disabled {
    opacity: 0.2;
    cursor: default;
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Navigation.vue